import { COLORS } from "../../../common/constants";

const styles = {
  btnPrimary: {
    background: `linear-gradient(135deg, rgba(41, 171, 226, 1) 0%,  ${COLORS.primary} 100%)`,
    borderRadius: "8px",
    textTransform: "capitalize",
    height: "36px",
    fontWeight: 900,
    minWidth: "110px",
    border: "1px solid rgba(41, 171, 226, 1)",
    fontSize: "12px",
    padding: "4px 8px",
    "&.MuiButtonBase-root": {
      "&:hover": {
        background: `linear-gradient(135deg, rgba(41, 171, 226, 1) 0%,  ${COLORS.primary} 100%)`,
      },
    },
    "& svg": {
      fontSize: "16px !important",
    },
  },
};
export default styles;
